import CashIcon from 'assets/icons/cash-icon.svg?component'
import UmbrellaIcon from 'assets/icons/umbrella-icon.svg?component'
import CashImage from 'assets/images/cash-image.png'
import ConditionBlock from 'components/UI/Blocks/ConditionBlock'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useAppSelector } from 'hooks'
import { useTranslation } from 'react-i18next'
import { getInsuranceDataSelector, loanParamsSelector } from 'redux/store/slices/decisionSlice'
import tw from 'twin.macro'
import { numberWithSpaces } from 'utils'

const LoanIncludes = () => {
  const { t } = useTranslation()

  // Selector
  const { creditSum, insuranceSum } = useAppSelector(getInsuranceDataSelector)
  const { amount } = useAppSelector(loanParamsSelector)

  return (
    <InfoBlock twStyle={tw`px-0`} isContentLoading={!creditSum || !amount || !insuranceSum}>
      <div tw='pb-5 px-5 flex items-center justify-between'>
        <div tw='flex flex-col gap-[2px]'>
          <Typography variant='caption' twStyle={tw`text-grey-dark`}>
            {t('loan-conditions.loan-amount', { ns: 'common' })}
          </Typography>
          <Heading variant='title2'>{numberWithSpaces(Number(amount).toFixed(0))} тг</Heading>
        </div>
        <img alt='cash' src={CashImage} />
      </div>
      <div tw='border-stroke border-t border-b py-4 px-5'>
        <Heading variant='body'>{t('in-total')}</Heading>
      </div>
      <div>
        <ConditionBlock
          caption={t('recieve-amount')}
          body={`${numberWithSpaces(Number(creditSum).toFixed(0))} ₸`}
          icon={<CashIcon />}
          twStyle={tw`border-b border-stroke`}
        />
        <ConditionBlock
          caption={t('insurance')}
          body={`${numberWithSpaces(Number(insuranceSum).toFixed(0))} ₸`}
          icon={<UmbrellaIcon />}
          twStyle={tw` pb-0`}
        />
      </div>
    </InfoBlock>
  )
}

export default LoanIncludes
